module.exports = __webpack_public_path__ + "static/media/heartipro-carrying-case-3.b75df198.png";